module.exports = "const cache = new CellMeasurerCache({ fixedWidth: true });\n\nfunction rowRenderer ({ index, key, parent, style }) {\n  return (\n    <CellMeasurer\n      cache={cache}\n      columnIndex={0}\n      key={key}\n      parent={parent}\n      rowIndex={index}\n    >\n      <div style={style}>{/* Your content here */}</div>\n    </CellMeasurer>\n  );\n}\n\nfunction renderList (props) {\n  return (\n    <List\n      {...props}\n      deferredMeasurementCache={cache}\n      rowHeight={cache.rowHeight}\n      rowRenderer={rowRenderer}\n    />\n  );\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/dynamic-cell-measurer.js
 ** module id = 276
 ** module chunks = 0
 **/